import styled from 'styled-components/macro';

export default styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
